import types from "./types";
import StorTypes from "../../../store/types";

const initialState = {
  petGuardian: { fullname: "", relationship: "" },
  alternatePetGuardian: { fullname: "", relationship: "" },
  childGuardian: { fullname: "", relationship: "" },
  alternateChildGuardian: { fullname: "", relationship: "" },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PET_GUARDIANS:
      return { ...state, petGuardian: action.payload };

    case types.ALT_PET_GUARDIAN:
      return { ...state, alternatePetGuardian: action.payload };

    case types.CHILD_GUARDIAN:
      return { ...state, childGuardian: action.payload };

    case types.ALT_CHILD_GUARDIAN:
      return { ...state, alternateChildGuardian: action.payload };

    case StorTypes.SET_DETAILS:
      // Extract guardian data from metadata
      const guardianMetadata = action.payload?.metadata?.sectionStatus?.guardian?.data || {};
      return {
        ...state,
        petGuardian: guardianMetadata.petGuardianFullname || guardianMetadata.petGuardian
          ? {
              fullname: guardianMetadata.petGuardianFullname || guardianMetadata.petGuardian?.fullname || "",
              relationship: guardianMetadata.petGuardianRelationship || guardianMetadata.petGuardian?.relationship || "",
            }
          : state.petGuardian,
        alternatePetGuardian: guardianMetadata.alternatePetGuardianFullname || guardianMetadata.alternatePetGuardian
          ? {
              fullname: guardianMetadata.alternatePetGuardianFullname || guardianMetadata.alternatePetGuardian?.fullname || "",
              relationship: guardianMetadata.alternatePetGuardianRelationship || guardianMetadata.alternatePetGuardian?.relationship || "",
            }
          : state.alternatePetGuardian,
        childGuardian: guardianMetadata.childGuardianFullname || guardianMetadata.childGuardian
          ? {
              fullname: guardianMetadata.childGuardianFullname || guardianMetadata.childGuardian?.fullname || "",
              relationship: guardianMetadata.childGuardianRelationship || guardianMetadata.childGuardian?.relationship || "",
            }
          : state.childGuardian,
        alternateChildGuardian: guardianMetadata.alternateChildGuardianFullname || guardianMetadata.alternateChildGuardian
          ? {
              fullname: guardianMetadata.alternateChildGuardianFullname || guardianMetadata.alternateChildGuardian?.fullname || "",
              relationship: guardianMetadata.alternateChildGuardianRelationship || guardianMetadata.alternateChildGuardian?.relationship || "",
            }
          : state.alternateChildGuardian,
      };

    default:
      return state;
  }
};

export default reducer;
